// Auth action types
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGIN_RESET = 'LOGIN_RESET';

export const REGISTER_USER_REQUEST = 'REGISTER_USER_REQUEST';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_FAIL = 'REGISTER_USER_FAIL';
export const REGISTER_USER_RESET = 'REGISTER_USER_RESET';

export const LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAIL = 'LOGOUT_USER_FAIL';
export const LOGOUT_USER_RESET = 'LOGOUT_USER_RESET';

// Complaint action types
export const REGISTER_COMPLAINT_REQUEST = 'REGISTER_COMPLAINT_REQUEST';
export const REGISTER_COMPLAINT_SUCCESS = 'REGISTER_COMPLAINT_SUCCESS';
export const REGISTER_COMPLAINT_FAIL = 'REGISTER_COMPLAINT_FAIL';
export const REGISTER_COMPLAINT_RESET = 'REGISTER_COMPLAINT_RESET';

export const GET_ALL_MY_COMPLAINT_REQUEST = 'GET_ALL_MY_COMPLAINT_REQUEST';
export const GET_ALL_MY_COMPLAINT_SUCCESS = 'GET_ALL_MY_COMPLAINT_SUCCESS';
export const GET_ALL_MY_COMPLAINT_FAIL = 'GET_ALL_MY_COMPLAINT_FAIL';

export const GET_ALL_EMPLOYEE_COMPLAINT_REQUEST = 'GET_ALL_EMPLOYEE_COMPLAINT_REQUEST';
export const GET_ALL_EMPLOYEE_COMPLAINT_SUCCESS = 'GET_ALL_EMPLOYEE_COMPLAINT_SUCCESS';
export const GET_ALL_EMPLOYEE_COMPLAINT_FAIL = 'GET_ALL_EMPLOYEE_COMPLAINT_FAIL';

export const GET_ALL_WORKERS_REQUEST = 'GET_ALL_WORKERS_REQUEST';
export const GET_ALL_WORKERS_SUCCESS = 'GET_ALL_WORKERS_SUCCESS';
export const GET_ALL_WORKERS_FAIL = 'GET_ALL_WORKERS_FAIL';

export const FIND_ARRIVED_COMPLAINT_REQUEST = 'FIND_ARRIVED_COMPLAINT_REQUEST';
export const FIND_ARRIVED_COMPLAINT_SUCCESS = 'FIND_ARRIVED_COMPLAINT_SUCCESS';
export const FIND_ARRIVED_COMPLAINT_FAIL = 'FIND_ARRIVED_COMPLAINT_FAIL';

export const ASSIGN_COMPLAINT_TO_WORKER_REQUEST = 'ASSIGN_COMPLAINT_TO_WORKER_REQUEST';
export const ASSIGN_COMPLAINT_TO_WORKER_SUCCESS = 'ASSIGN_COMPLAINT_TO_WORKER_SUCCESS';
export const ASSIGN_COMPLAINT_TO_WORKER_FAIL = 'ASSIGN_COMPLAINT_TO_WORKER_FAIL';
export const ASSIGN_COMPLAINT_TO_WORKER_RESET = 'ASSIGN_COMPLAINT_TO_WORKER_RESET';

export const CHANGE_STATUS_OF_COMPLAINT_REQUEST = 'CHANGE_STATUS_OF_COMPLAINT_REQUEST';
export const CHANGE_STATUS_OF_COMPLAINT_SUCCESS = 'CHANGE_STATUS_OF_COMPLAINT_SUCCESS';
export const CHANGE_STATUS_OF_COMPLAINT_FAIL = 'CHANGE_STATUS_OF_COMPLAINT_FAIL';
export const CHANGE_STATUS_OF_COMPLAINT_RESET = 'CHANGE_STATUS_OF_COMPLAINT_RESET';

export const FILTER_COMPLAINT_REQUEST = 'FILTER_COMPLAINT_REQUEST';
export const FILTER_COMPLAINT_SUCCESS = 'FILTER_COMPLAINT_SUCCESS';
export const FILTER_COMPLAINT_FAIL = 'FILTER_COMPLAINT_FAIL';
export const FILTER_COMPLAINT_RESET = 'FILTER_COMPLAINT_RESET'; 